import Tool, { type ToolHandler } from '../Tool';
import type { AssistantToolCall } from 'components/framework/models';
import type Agent from '../../agents/Agent';

/**
 * Handler for Develop:MoveTeamRecordsTool.
 * Refreshes the boards when the tool completes successfully.
 */
const moveTeamRecordsToolHandler: ToolHandler = {
  processToolCall(toolCall: AssistantToolCall, agent: Agent): void {
    if (toolCall.status === 'complete' && toolCall.attributes) {
      refreshDevelopBoards();
    }
  },
};

// Unfortunately, there's no way to detect if the update was a repioritization vs a move to a different location.
// The boards do not automatically refresh if a record changes position in the same location, so
// we refresh the boards on any successful completion of the tool.
function refreshDevelopBoards(): void {
  const path = window.location.pathname;

  if (path.match(/(backlogs|iterations|workflow_board)/)) {
    window.dispatchEvent(new CustomEvent('assistant:location-updated'));
  }
}

Tool.register('Develop::MoveTeamRecordsTool', moveTeamRecordsToolHandler);
